export default "__VITE_ASSET__BeFpa0Dj__"